export default __webpack_public_path__ + "static/media/Saudi_Arabia.d89533c1.svg";